import { useCallback, useState } from 'react';
import { css } from '@emotion/css';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, FilterActions, Input } from '@lyearn/ui';
import { FilterOperators } from '@/components/Filter/types';
import { FilterBodyProps } from '@/components/FilterNew/components/Body/types';
import FilterHeader from '@/components/FilterNew/components/Header';
import { FilterOperatorEnum } from '@/types/schema';

const DISABLED_TEXT_OPERATORS = [FilterOperatorEnum.IsEmpty, FilterOperatorEnum.IsNotEmpty];

const inputStyles = css`
  height: 125px;
  max-height: 125px;
`;

const TextFilter = ({
  uiConfig,
  onChange,
  headerProps,
  initialSelectedOptions,
  initialSelectedOperator,
}: FilterBodyProps) => {
  const { t } = useTranslation();
  const { showActionButtons = true } = uiConfig ?? {};
  const [selectedOperator, setSelectedOperator] = useState<FilterOperators | undefined>(
    initialSelectedOperator,
  );
  const [inputVal, setInputVal] = useState(() => {
    return typeof initialSelectedOptions !== 'string' ? '' : initialSelectedOptions;
  });

  const onClear = useCallback(() => {
    onChange([
      {
        value: '',
        label: '',
      },
    ]);
  }, [onChange]);

  const onSave = useCallback(() => {
    onChange([
      {
        label: inputVal,
        value: inputVal,
      },
    ]);
  }, [inputVal, onChange]);

  return (
    <Box className="w-[28rem] xs:w-full">
      <FilterHeader
        {...headerProps}
        operatorsActions={{
          methods: {
            setSelectedOperator,
          },
          selectedOperator,
        }}
      />
      <Input
        autoFocus
        multiline
        className={cn('w-full border-none', inputStyles)}
        disabled={selectedOperator && DISABLED_TEXT_OPERATORS.includes(selectedOperator.value)}
        placeholder={t('Tags:AddTextHere')}
        value={inputVal}
        variant="body-short-02"
        onChange={(e) => setInputVal(e.target.value)}
      />
      {showActionButtons ? <FilterActions onClear={onClear} onSave={onSave} /> : null}
    </Box>
  );
};

export default TextFilter;
